import Swiper from 'swiper/swiper-bundle';
import 'swiper/swiper-bundle.min.css';

const statsSlider = () => {
    const sliders = document.querySelectorAll('.js-stats-slider');

    if ( sliders ) {
        sliders.forEach(slider => {
            const slideCount = parseInt(slider.getAttribute('data-slide-count'));
            const navigation = {
                nextEl: slider.parentElement.querySelector('.swiper-button-next'),
                prevEl: slider.parentElement.querySelector('.swiper-button-prev'),
            };
            const smLoop = slideCount === 2 ? false : true;
            const mdLoop = slideCount === 2 ? false : true;
            const lgLoop = slideCount === 3 ? false : true;
            const smArrows = slideCount === 2 ? false : navigation;
            const mdArrows = slideCount === 2 ? false : navigation;
            const lgArrows = slideCount === 3 ? false : navigation;

            const swiper = new Swiper(slider, {
                slidesPerView: 1,
                loop: true,
                speed: 500,
                a11y: true,
                navigation: navigation,
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                        loop: smLoop,
                        navigation: smArrows
                    },
                    768: {
                        slidesPerView: 3,
                        loop: mdLoop,
                        navigation: mdArrows
                    },
                    992: {
                        slidesPerView: 4,
                        loop: lgLoop,
                        navigation: lgArrows
                    },
                    1200: {
                        slidesPerView: slider.getAttribute('data-slide-count'),
                        loop: false
                    }
                }
            });
        });
    }
}

statsSlider();